import { useQuery } from '@apollo/client/react';

import { listQuery } from '../../services/EstablishmentService';

export const useEstablishments = (filter, { limit, offset }) => {
  const { data, loading, error } = useQuery(listQuery, {
    fetchPolicy: 'cache-and-network',
    variables: { filter, limit, offset }
  });

  return { establishments: data?.establishments ?? [], loading, error };
};
